/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import moment from 'moment';
import { Form, Tooltip, notification } from 'antd';
import { ThumbsUp, ThumbsDown, Hourglass, ClipboardList } from 'lucide-react';
import {
  fetchCalenderDetails,
  fetchLogDetails,
  generateLogReports,
} from '../redux/logDetails/action';
import { fetchSowDetails } from '../redux/sowDetails/actions';
import GenerateReport from './GenerateReport';
import LogCalender from './LogCalender';
import './LogDetails.css';

const LogDetails = (props) => {
  const {
    onFetchLogDetails,
    logDetails,
    showLogLoader,
    selectedProject,
    onFetchSowDetails,
    sowDetails,
    onGenerateLogReports,
    onFetchCalenderDetails,
    isCalenderLoading,
    calenderData,
    isLogReportsLoading,
    projectTeamMembersAccessList,
    userAccessList,
  } = props;

  const [isReportModalVisible, setIsReportModalVisible] = useState(false);
  const [columnList, setColoumList] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [locationData, setLocationData] = useState([]);
  const [projectIdValue, setProjectIdValue] = useState(false);

  const [pipeline, setPipeline] = useState(null);
  const [selectedPipeline, setSelectedPipeline] = useState(null);
  const [yearData, setYearData] = useState(moment().format('YYYY'));
  const [monthData, setMonthData] = useState(moment().format('MM'));
  const [calenderList, setCalenderList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  const [calenderForm] = Form.useForm();
  const [calenderView, setCalenderView] = useState(false);
  const [calenderClass, setCalenderClass] = useState('hide');

  const isButtonDisabled = () => {
    if (userAccessList.includes('admin') || userAccessList.includes('super-admin')) return false;
    else if (projectTeamMembersAccessList[0]?.isGuestUser) {
      return true;
    } else if (
      projectTeamMembersAccessList[0]?.isNormalUser &&
      !projectTeamMembersAccessList[0]?.tabPermissions?.Log?.write
    ) {
      return true;
    } else {
      return false;
    }
  };
  const isWriteAccess = isButtonDisabled();

  useEffect(() => {
    const projId = get(selectedProject, 'id', undefined);
    if (projId) {
      onFetchSowDetails(projId);
      setLocationData([]);
      setPipeline('');
      setSelectedPipeline('');
      setYearData(moment().format('YYYY'));
      setMonthData(moment().format('MM'));
      calenderForm.resetFields();
      setCalenderList([]);
      setDataList([]);
      setColoumList([]);
      setCalenderView(false);
      setCalenderClass('hide');
    }
    setProjectIdValue(projId);
  }, [selectedProject]);

  useEffect(() => {
    setLocationData(sowDetails);
  }, [sowDetails]);

  useEffect(() => {
    let logColoums = [];
    let logDataSource = [];
    if (logDetails) {
      setTotalCount(logDetails.totalCount);
      if (logDetails.columns) {
        logDetails.columns.map((item) => {
          item.width = 170;
          item.align = 'center';
          item.ellipsis = {
            showTitle: false,
          };
          (item.render = (address) => (
            <Tooltip
              placement="topLeft"
              title={address}
            >
              {address}
            </Tooltip>
          )),
            (item.render = (text, record) => {
              return (
                <div>
                  {text === 'accept' ? (
                    <ThumbsUp
                      className="log-status-icon log-status-icon--accept"
                      size={20}
                      strokeWidth={2}
                      aria-label="Accept"
                    />
                  ) : text === 'reject' ? (
                    <ThumbsDown
                      className="log-status-icon log-status-icon--reject"
                      size={20}
                      strokeWidth={2}
                      aria-label="Reject"
                    />
                  ) : text === 'pending' ? (
                    <Tooltip title="Pending">
                      <Hourglass
                        className="log-status-icon log-status-icon--pending"
                        size={20}
                        strokeWidth={2}
                        aria-hidden
                      />
                    </Tooltip>
                  ) : (
                    text
                  )}
                </div>
              );
            }),
            logColoums.push(item);
        });

        logColoums.forEach((item, i) => {
          if (item.title === 'Weld') {
            item.title = 'Weld #';
            item.width = 200;
            item.align = 'center';
            item.fixed = 'left';
            item.ellipsis = {
              showTitle: false,
            };
            (item.render = (address) => (
              <Tooltip
                placement="topLeft"
                title={address}
              >
                {address}
              </Tooltip>
            )),
              logColoums.splice(i, 1);
            logColoums.unshift(item);
          }

          if (item.title === 'Repair Status') {
            item.fixed = 'right';
            logColoums.splice(i, 1);
            logColoums.splice(logColoums.length - 1, 0, item);
          }

          if (item.title === 'Overall Status') {
            item.fixed = 'right';
          }
        });

        logColoums.forEach((item, i) => {
          if (item.title) {
            item.ellipsis = {
              showTitle: false,
            };
            item.title = <Tooltip title={item.title}>{item.title}</Tooltip>;
          }
        });

        logColoums.forEach((item, i) => {
          if (item.title) {
            item.ellipsis = {
              showTitle: false,
            };
            item.title = <Tooltip title={item.title}>{item.title}</Tooltip>;
          }
        });
        setColoumList(logColoums);
      }

      if (logDetails.dataSource) {
        var sizeCount = JSON.parse(sessionStorage.getItem('page'));
        logDetails.dataSource.map((item, i) => {
          if (sizeCount.pageIndex > 0) {
            item.count = i + 1 + sizeCount.pageSize * sizeCount.pageIndex;
          } else {
            item.count = i + 1;
          }

          logDataSource.push(item);
        });
        setDataList(logDataSource);
      }
    }
  }, [logDetails]);

  useEffect(() => {
    if (calenderData) {
      setCalenderList(calenderData);
    }
  }, [calenderData]);

  const onGenerateReport = async (data) => {
    await onGenerateLogReports(data);
  };

  const getCalData = async (data) => {
    await onFetchCalenderDetails(data);
  };

  return (
    <div className="modern-log-page">
      <div className="log-page-header">
        <div className="log-page-header-text">
          <div className="log-page-header-icon" aria-hidden>
            <ClipboardList size={22} color="#2563eb" />
          </div>
          <div className="log-page-header-titles">
            <h1 className="log-page-title">Inspection Report</h1>
            <p className="log-page-subtitle">
              Pipeline calendar, weld counts, and daily log details for this project.
            </p>
          </div>
        </div>
        <div className="log-page-header-actions">
          <GenerateReport
            isReportModalVisible={isReportModalVisible}
            setIsReportModalVisible={setIsReportModalVisible}
            setLocationData={setLocationData}
            locationData={locationData}
            projectIdValue={projectIdValue}
            onGenerateReport={onGenerateReport}
            isLogReportsLoading={isLogReportsLoading}
            isWriteAccess={isWriteAccess}
          />
        </div>
      </div>

      <div className="log-page-content">
        <LogCalender
          locationData={locationData}
          dataList={dataList}
          setDataList={setDataList}
          showLogLoader={showLogLoader}
          columnList={columnList}
          totalCount={totalCount}
          setCalenderView={setCalenderView}
          calenderView={calenderView}
          calenderClass={calenderClass}
          setCalenderClass={setCalenderClass}
          pipeline={pipeline}
          setPipeline={setPipeline}
          selectedPipeline={selectedPipeline}
          setSelectedPipeline={setSelectedPipeline}
          yearData={yearData}
          setYearData={setYearData}
          monthData={monthData}
          setMonthData={setMonthData}
          calenderForm={calenderForm}
          getCalData={getCalData}
          calenderList={calenderList}
          isCalenderLoading={isCalenderLoading}
          onFetchLogDetails={onFetchLogDetails}
          isWriteAccess={isWriteAccess}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({ log, sow }) => {
  const logDetails = get(log, 'logData', []);
  const reportsData = get(log, 'reportsData', []);
  const showLogLoader = get(log, 'isLogDetailsLoading', false);
  const sowDetails = get(sow, 'sowData', []);
  const isCalenderLoading = get(log, 'isCalenderLoading', []);
  const calenderData = get(log, 'calenderData', []);
  const isLogReportsLoading = get(log, 'isLogReportsLoading', []);
  return {
    logDetails,
    showLogLoader,
    sowDetails,
    reportsData,
    isCalenderLoading,
    calenderData,
    isLogReportsLoading,
  };
};

const mapDispatchToProps = {
  onFetchLogDetails: fetchLogDetails,
  onFetchSowDetails: fetchSowDetails,
  onGenerateLogReports: generateLogReports,
  onFetchCalenderDetails: fetchCalenderDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(LogDetails);
